import React from "react";
import type { Feedback } from "../utils/form-util";

export interface Validation {
  validated: boolean;
  validationCounter: number;
  validationFeedback: Feedback[];
  suppressFieldErrors: boolean;
  validate(event: React.SyntheticEvent<HTMLFormElement>): boolean;
  validateForm(form: HTMLFormElement): boolean;
}

const ValidationContext = React.createContext<Validation>({
  validated: false,
  validationCounter: 0,
  validationFeedback: [],
  suppressFieldErrors: false,
  validate: () => false,
  validateForm: () => false,
});

export default ValidationContext;
